import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy URL — the supplier list now lives at /suppliers/list.
export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/search/list')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/configuration/vendor-management/suppliers/list',
            params,
            replace: true,
        });
    },
});
